function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.313.792c0-.79-1.038-1.088-1.495-.433C1.625 6.37 7.583 6.641 7.583 9.563c0 1.183-.985 2.14-2.195 2.124A2.165 2.165 0 013.25 9.531v-2.84c0-.72-.896-1.07-1.403-.547C.941 7.078 0 8.677 0 10.625 0 14.14 2.916 17 6.5 17s6.5-2.86 6.5-6.375C13 4.971 7.312 4.217 7.312.792z",
  fill: "#E50000",
  fillRule: "nonzero"
});

function SvgDailyDeals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 17
  }, props), _ref);
}

export default SvgDailyDeals;